import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CallToAction.css';

const CallToAction = () => {
  return (
    <section className="call-to-action-box no-padding" style={{backgroundColor:'#FFF', }}>
      <div className="container" >
        <div className="action-style-box py-4" style={{backgroundColor:'#000', border:'6px #917232 solid', borderRadius:'0 0 30px 30px'}}>
          <div className="row align-items-center" >
            <div className="col-md-12 text-center text-md-start">
              <div className="call-to-action-text">
                <h3 className="action-title text-white text-center">Anticiper le risque, assurer la paix. </h3>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
